import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Cubre el seguro SAINT® TMS?",
    answer:
      "La cobertura varía según el plan. Es posible que esté cubierto; verificamos sus beneficios sin costo. El pago directo para SAINT® puede oscilar entre $25,000 y $28,000. [[Verifique sus beneficios|/es/saint-tms-insurance-coverage]] o llame al 954-827-9793.",
  },
  {
    question: "¿SAINT® TMS está cubierto por Medicaid o Medicare?",
    answer:
      "La cobertura varía según el plan. Verificamos sus beneficios sin costo, sea cual sea su aseguradora. No afirmamos estar dentro de la red de ninguna aseguradora. La cobertura varía según el plan.",
  },
];

export const esIsSaintCoveredByInsurance = makeEsArticle({
  slug: "is-saint-tms-covered-by-insurance",
  title: "¿SAINT® TMS está cubierto por el seguro? | Neuro Wellness",
  description:
    "La cobertura de SAINT® TMS varía según el plan. Es posible que esté cubierto; verificamos sus beneficios sin costo, sea cual sea su aseguradora.",
  h1: "¿SAINT® TMS está cubierto por el seguro?",
  breadcrumbLabel: "¿Cubre el seguro SAINT®?",
  shortAnswer:
    "La cobertura de SAINT® TMS varía según el plan. Es posible que esté cubierto; verificamos sus beneficios sin costo, sea cual sea su aseguradora. No afirmamos estar dentro de la red de ninguna aseguradora; la cobertura varía según el plan. El pago directo para SAINT® puede oscilar entre $25,000 y $28,000. [[Verifique sus beneficios|/es/saint-tms-insurance-coverage]] o llame al 954-827-9793.",
  keyTakeaways: [
    "La cobertura varía según el plan.",
    "Es posible que esté cubierto.",
    "Verificamos sus beneficios sin costo.",
    "No afirmamos estar dentro de la red de ninguna aseguradora.",
    "El pago directo puede oscilar entre $25,000 y $28,000.",
  ],
  sections: [
    {
      heading: "Cobertura del seguro",
      paragraphs: [
        "La cobertura de SAINT® TMS varía según el plan. Es posible que esté cubierto. Verificamos sus beneficios sin costo, sea cual sea su aseguradora. No afirmamos estar dentro de la red de ninguna aseguradora; la cobertura varía según el plan.",
      ],
    },
    {
      heading: "Pago directo",
      paragraphs: [
        "El pago directo para SAINT® puede oscilar entre $25,000 y $28,000. [[Verifique sus beneficios|/es/saint-tms-insurance-coverage]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
